// extracted by mini-css-extract-plugin
export default {"container":"OperationSelection_container__njhCq"};